import _extends from "@babel/runtime/helpers/esm/extends";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Components as TypeaheadMultiSelectComponents } from './typeaheadMultiSelect.style';
import { MultiValueLabel } from './TypeaheadMultiSelect';
import { LoadingIndicator } from '..';
import { components } from 'react-select';
import Icon from '../Icon';
import Label from '../Label';
const TypeaheadMultiSelectInput = props => {
  const {
      label,
      renderValue = 'value',
      onInputChange,
      isLoading,
      width,
      fit = 'medium'
    } = props,
    rest = __rest(props, ["label", "renderValue", "onInputChange", "isLoading", "width", "fit"]);
  const [menuOpen, setMenuOpen] = useState(false);
  const DropdownIndicator = props => {
    return _jsx(components.DropdownIndicator, _extends({}, props, {
      children: _jsx(Icon, {
        name: "chevron-down",
        size: fit === 'large' ? '24' : '20'
      })
    }));
  };
  const onInputValueChange = (val, action) => {
    if (val !== '') {
      setMenuOpen(true);
    } else {
      setMenuOpen(false);
    }
    if (typeof onInputChange === 'function') {
      onInputChange(val, action);
    }
  };
  return _jsxs(TypeaheadMultiSelectComponents.Wrapper, _extends({
    width: width
  }, {
    children: [label && _jsx(Label, _extends({
      fit: fit,
      label: label
    }, rest)), _jsx(TypeaheadMultiSelectComponents.StyledSelect, _extends({
      classNamePrefix: "MultiSelect",
      isMulti: true,
      onInputChange: onInputValueChange,
      menuIsOpen: menuOpen,
      components: {
        MultiValueLabel: props => _jsx(MultiValueLabel, _extends({}, props, {
          renderValue: renderValue
        })),
        LoadingIndicator: undefined,
        DropdownIndicator
      },
      loadingMessage: () => _jsx(LoadingIndicator, {}),
      isLoading: isLoading
    }, rest))]
  }));
};
export default TypeaheadMultiSelectInput;